import { render, staticRenderFns } from "./PTable.vue?vue&type=template&id=52363e05&scoped=true&"
import script from "./PTable.vue?vue&type=script&lang=ts&"
export * from "./PTable.vue?vue&type=script&lang=ts&"
import style0 from "./PTable.vue?vue&type=style&index=0&id=52363e05&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52363e05",
  null
  
)

export default component.exports